<template>
    <v-dialog max-width="500px" :value="true">
        <v-card>
            <v-toolbar dark dense flat color="primary">
                <v-toolbar-title>Question Scoring</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pt-2">
                <v-row>
                    <v-text-field outlined
                                  hide-details
                                  label="Enter Score">
                    </v-text-field>
                </v-row>
                <v-row class="pt-2">
                    <v-textarea outlined hide-details
                                label="Enter notes"></v-textarea>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined color="primary">Cancel</v-btn>
                <v-btn depressed
                       @click="saveScore"
                       color="primary">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: "AnswerScoring",

    data() {
      return {}
    },

    methods: {
      saveScore () {

      }
    }
  }
</script>

<style scoped>

</style>
